import { seatable } from '@ui/canvas/utils'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'

export const convertEmployeesWorkplaceGroupsSpacesToPoints = ({
  ids,
  byId,
}: {
  ids: any
  byId: any
}) => {
  const sp = ids.reduce((result: any, id: any) => {
    const s = byId[id]
    return seatable(s.spaceType) ? [...result, s] : result
  }, [])

  return sp.map((pro: any) => {
    const { x, y, w, code, spaceAssignment } = pro
    const point: any = [x, y]
    point.w = w
    point.workplaceGroup =
      get(spaceAssignment, 'employee.workplaceGroups[0]') ||
      spaceAssignment?.sharedEmployees?.reduce((result: any, item: any) => {
        if (item.workplaceGroup) {
          return item.workplaceGroup
        }

        return null
      }, null)
    point.code = code
    point.occupied = Boolean(spaceAssignment.employee)
    return point
  })
}

export const convertSpacesWorkplaceGroupsSpacesToPoints = ({
  ids,
  byId,
}: {
  ids: any
  byId: any
}) => {
  const sp = ids.reduce((result: any, id: any) => {
    const s = byId[id]
    return seatable(s.spaceType) ? [...result, s] : result
  }, [])

  return sp.map((pro: any) => {
    const { x, y, w, code, workplaceGroups, spaceAssignment } = pro
    const point: any = [x, y]
    point.w = w
    point.workplaceGroups = workplaceGroups || null
    point.code = code
    point.occupied = Boolean(spaceAssignment.employee) || Boolean(spaceAssignment.sharedEmployees)
    return point
  })
}

export const groupWorkplaceGroupCluster = (cluster: any) =>
  groupBy(cluster, ({ workplaceGroups }) => get(workplaceGroups[0], 'id'))

export const groupEmpWorkplaceGroupCluster = (cluster: any) =>
  groupBy(cluster, ({ workplaceGroup }) => get(workplaceGroup, 'id'))
